import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import useCoachMemoQuery from '#hooks/queries/schedules/useCoachMemoQuery';
import useCoachNoticeQuery from '#hooks/queries/schedules/useCoachNoticeQuery';
import { CalendarPeriodic } from '../../types';
import CardMemo from './CardMemo';
import CardNotice from './CardNotice';
import * as S from './styles';

interface Props {
  calendarPeriodic: CalendarPeriodic;
  date?: string | dayjs.Dayjs;
}

export default function CardMemoWrapper({ calendarPeriodic, date }: Props) {
  const [dateObj, setDateObj] = useState<dayjs.Dayjs>();
  const { data: memo, isLoading: isLoadingMemo } = useCoachMemoQuery({
    memoType: calendarPeriodic,
    date: dateObj?.format('YYYY-MM-DD'),
    year: dateObj?.get('year'),
    month: dateObj?.get('month') ? dateObj?.get('month') + 1 : undefined,
    week: dateObj?.week()
  });
  const { data: notice, isLoading: isLoadingNotice } = useCoachNoticeQuery();

  useEffect(() => {
    if (date) {
      setDateObj(dayjs(date));
    }
  }, [date]);

  return (
    <S.Wrapper>
      {!isLoadingNotice && notice?.body && (
        <CardNotice
          title={notice?.title}
          body={notice?.body}
          isVisible={notice?.isVisible}
        />
      )}
      {!isLoadingMemo && memo?.memo && (
        <>
          <CardMemo memo={memo?.memo} isVisible={memo?.isVisible} />
        </>
      )}
    </S.Wrapper>
  );
}
